module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.productIds.length >= 1) ? _c('div', {
    staticClass: "donate-pre-form wwf-form row small-collapse medium-uncollapse",
    class: {
      'dark': _vm.isDark, 'light': !_vm.isDark
    }
  }, [_c('div', [(this.productIds.length > 1) ? _c('div', {
    staticClass: "small-12 columns first-column"
  }, [_c('div', {
    staticClass: "row small-collapse"
  }, [_c('ul', {
    staticClass: "type-tab wwf-radio-bttns"
  }, _vm._l((_vm.productidsdetail), function(productdetail) {
    return _c('li', [_c('label', {
      staticClass: "wwf-controls radio",
      attrs: {
        "for": 'product-' + productdetail.productname
      }
    }, [_vm._v(_vm._s(productdetail.productname) + "\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product),
        expression: "product"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "radio",
        "name": "product",
        "id": 'product-' + productdetail.productname
      },
      domProps: {
        "value": productdetail,
        "checked": _vm._q(_vm.product, productdetail)
      },
      on: {
        "change": function($event) {
          _vm.product = productdetail
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "control__indicator"
    })])])
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('product')),
      expression: "errors.has('product')"
    }],
    staticClass: "alert-box"
  }, [_vm._v(_vm._s(_vm.errors.first('product')))])])]) : _vm._e(), _vm._v(" "), (!_vm.emailprefill) ? _c('div', {
    staticClass: "small-12 medium-8 medium-centered columns"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "small-12 columns dollar-handles"
  }, [(_vm.product) ? _c('div', [_vm._l((_vm.product.dollarhandles[_vm.product.donationtypes[0]]), function(dollarhandle, index) {
    return _c('label', {
      staticClass: "wwf-controls radio",
      attrs: {
        "for": "handle0"
      }
    }, [_c('span', {
      class: {
        selected: dollarhandle.amount === _vm.handle
      }
    }, [_vm._v("$" + _vm._s((dollarhandle.amount.indexOf('.00') >= 0) ? dollarhandle.amount.slice(0, -3) : dollarhandle.amount))]), _vm._v(" "), (!_vm.dollarhandleclick) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.handle),
        expression: "handle"
      }],
      attrs: {
        "type": "radio",
        "name": 'handle' + index,
        "id": 'handle' + index
      },
      domProps: {
        "value": dollarhandle.amount,
        "checked": _vm._q(_vm.handle, dollarhandle.amount)
      },
      on: {
        "change": function($event) {
          _vm.handle = dollarhandle.amount
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.dollarhandleclick) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.handle),
        expression: "handle"
      }],
      attrs: {
        "type": "radio",
        "name": 'handle' + index,
        "id": 'handle' + index
      },
      domProps: {
        "value": dollarhandle.amount,
        "checked": _vm._q(_vm.handle, dollarhandle.amount)
      },
      on: {
        "click": function($event) {
          _vm.donateclick(dollarhandle.amount)
        },
        "change": function($event) {
          _vm.handle = dollarhandle.amount
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "control__indicator"
    })])
  }), _vm._v(" "), _c('label', {
    staticClass: "wwf-controls radio",
    attrs: {
      "for": "handle4"
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt",
    class: {
      selected: _vm.handle === 'custom'
    }
  }), _vm._v(" "), (!_vm.dollarhandleclick) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handle),
      expression: "handle"
    }],
    attrs: {
      "type": "radio",
      "name": "handle",
      "value": "custom",
      "id": "handle4"
    },
    domProps: {
      "checked": _vm._q(_vm.handle, "custom")
    },
    on: {
      "change": function($event) {
        _vm.handle = "custom"
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dollarhandleclick) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handle),
      expression: "handle"
    }],
    attrs: {
      "type": "radio",
      "name": "handle",
      "value": "custom",
      "id": "handle4"
    },
    domProps: {
      "checked": _vm._q(_vm.handle, "custom")
    },
    on: {
      "click": function($event) {
        _vm.donateclick('custom')
      },
      "change": function($event) {
        _vm.handle = "custom"
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control__indicator"
  })])], 2) : _vm._e()]), _vm._v(" "), (!this.dollarhandleclick) ? _c('div', {
    staticClass: "small-12 columns"
  }, [_c('a', {
    staticClass: "bttn-lrg-arrw",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": _vm.donate
    }
  }, [_vm._v("Donate")])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e68387d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=csplt5ikear!./~/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./src/components/product/DonateRgForm.vue
// module id = 683
// module chunks = 0